export const patterns = {
  // Regex source: https://ui.dev/validate-email-address-javascript/
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
